import { AndroidAppDevelopmentComponent } from "../pages/services/android-app-development/android-app-development.component";

export const schemaData = {
  homenew: {
    id: 'home-script',
    content: JSON.stringify({
     "@context": "https://schema.org",
      "@type": "homePage",
      "name": "Vidhema Technologies | Innovative IT Solutions & Services",
      "description": "Vidhema Technologies is known for Delivering exceptional eCommerce Development, Mobile App Development, CRM Solutions and ERP Solutions.",
      "url": "https://vidhema.com/",
      "mainEntity":
       {
        "@type": "Organization",
        "name": "Vidhema Technologies",
        "telephone": "+1-234-567-8900",
        "email": "info@vidhema.com",
        "address": [
        {
          "@type": "PostalAddress",
          "streetAddress": "123 Tech Street",
          "addressLocality": "Silicon Valley",
          "addressRegion": "CA",
          "postalCode": "94000",
          "addressCountry": "US"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "68 ",
          "addressLocality": "CIRCULAR ROAD",
          "addressRegion": "SG",
          "postalCode": "049422",
          "addressCountry": "SINGAPORE"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "7, Shanti Nagar Rd",
          "addressLocality": "Shanthi Nagar,Jaipur",
          "addressRegion": "IN",
          "postalCode": "302020",
          "addressCountry": "INDIA"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "403, Ashirwad Nilayam",
          "addressLocality": "Camelot Layout,Hyderabad",
          "addressRegion": "IN",
          "postalCode": "500084",
          "addressCountry": "INDIA"
        },
        ],
        "sameAs": [
          "https://www.facebook.com/vidhematechnologies",
          "https://www.linkedin.com/company/vidhema-technologies",
          "https://twitter.com/vidhematech"
        ],
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "+1-234-567-8901",
            "email": "support@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          },
          {
            "@type": "ContactPoint",
            "contactType": "sales",
            "telephone": "+1-234-567-8902",
            "email": "sales@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          }
        ],
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "value": 100
        },
        "founder": [
          {
            "@type": "Person",
            "name": " Avinash Verma"
          },
          {
            "@type": "Person",
            "name": "Vivek Chaturvedi"
          },
          {
              "@type": "Person",
              "name": "Anoop Singh Chouhan"
            }
        ]
      }
    })
  },
  aboutus: {
    id: 'about-script',
    content: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "aboutusPage",
      "name": "About Vidhema Technology | Leading Web & Software Development Company",
      "description":  "Learn about Vidhema Technology, a leading web and software development company. Discover our expertise, values, and commitment to delivering innovative IT solutions.",
      "url": "https://vidhema.com/about-us.html",
      "mainEntity":
       {
        "@type": "Organization",
        "name": "Vidhema Technologies",
        "telephone": "+1-234-567-8900",
        "email": "info@vidhema.com",
        "address": [
        {
          "@type": "PostalAddress",
          "streetAddress": "123 Tech Street",
          "addressLocality": "Silicon Valley",
          "addressRegion": "CA",
          "postalCode": "94000",
          "addressCountry": "US"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "68 ",
          "addressLocality": "CIRCULAR ROAD",
          "addressRegion": "SG",
          "postalCode": "049422",
          "addressCountry": "SINGAPORE"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "7, Shanti Nagar Rd",
          "addressLocality": "Shanthi Nagar,Jaipur",
          "addressRegion": "IN",
          "postalCode": "302020",
          "addressCountry": "INDIA"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "403, Ashirwad Nilayam",
          "addressLocality": "Camelot Layout,Hyderabad",
          "addressRegion": "IN",
          "postalCode": "500084",
          "addressCountry": "INDIA"
        },
        ],
        "sameAs": [
          "https://www.facebook.com/vidhematechnologies",
          "https://www.linkedin.com/company/vidhema-technologies",
          "https://twitter.com/vidhematech"
        ],
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "+1-234-567-8901",
            "email": "support@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          },
          {
            "@type": "ContactPoint",
            "contactType": "sales",
            "telephone": "+1-234-567-8902",
            "email": "sales@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          }
        ],
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "value": 100
        },
        "founder": [
          {
            "@type": "Person",
            "name": " Avinash Verma"
          },
          {
            "@type": "Person",
            "name": "Vivek Chaturvedi"
          },
          {
              "@type": "Person",
              "name": "Anoop Singh Chouhan"
            }
        ]
      }
    })
  },
  contactus: {
    id: 'contact-script',
    content: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "name": "Contact Vidhema Technologies",
      "description": "Get in touch with Vidhema Technologies for your IT solutions",
      "url": "https://www.vidhema.com/contact",
      "mainEntity": {
        "@type": "Organization",
        "name": "Vidhema Technologies",
        "telephone": "+1-234-567-8900",
        "email": "info@vidhema.com",
        "address": [
          {
            "@type": "PostalAddress",
            "streetAddress": "123 Tech Street",
            "addressLocality": "Silicon Valley",
            "addressRegion": "CA",
            "postalCode": "94000",
            "addressCountry": "US"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "68 ",
            "addressLocality": "CIRCULAR ROAD",
            "addressRegion": "SG",
            "postalCode": "049422",
            "addressCountry": "SINGAPORE"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "7, Shanti Nagar Rd",
            "addressLocality": "Shanthi Nagar,Jaipur",
            "addressRegion": "IN",
            "postalCode": "302020",
            "addressCountry": "INDIA"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "403, Ashirwad Nilayam",
            "addressLocality": "Camelot Layout,Hyderabad",
            "addressRegion": "IN",
            "postalCode": "500084",
            "addressCountry": "INDIA"
          }
        ],
        "sameAs": [
          "https://www.facebook.com/vidhematechnologies",
          "https://www.linkedin.com/company/vidhema-technologies",
          "https://twitter.com/vidhematech"
        ],
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "+1-234-567-8901",
            "email": "support@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          },
          {
            "@type": "ContactPoint",
            "contactType": "sales",
            "telephone": "+1-234-567-8902",
            "email": "sales@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          }
        ],
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "value": 100
        },
        "founder": [
          {
            "@type": "Person",
            "name": "Avinash Verma"
          },
          {
            "@type": "Person",
            "name": "Vivek Chaturvedi"
          },
          {
            "@type": "Person",
            "name": "Anoop Singh Chouhan"
          }
        ]
      }
    })
  },
  career: {
    id: 'career-script',
    content: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "careerPage",
      "name": "Careers at Vidhema Technology | Join Our Innovative Tech Team",
      "description":  "Explore exciting career opportunities at Vidhema Technology. Join our team of innovative professionals in web and software development, and be part of cutting-edge tech projects.",
      "url": "https://vidhema.com/career.html",
      "mainEntity": {
        "@type": "Organization",
        "name": "Vidhema Technologies",
        "telephone": "+1-234-567-8900",
        "email": "info@vidhema.com",
        "address": [
          {
            "@type": "PostalAddress",
            "streetAddress": "123 Tech Street",
            "addressLocality": "Silicon Valley",
            "addressRegion": "CA",
            "postalCode": "94000",
            "addressCountry": "US"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "68 ",
            "addressLocality": "CIRCULAR ROAD",
            "addressRegion": "SG",
            "postalCode": "049422",
            "addressCountry": "SINGAPORE"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "7, Shanti Nagar Rd",
            "addressLocality": "Shanthi Nagar,Jaipur",
            "addressRegion": "IN",
            "postalCode": "302020",
            "addressCountry": "INDIA"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "403, Ashirwad Nilayam",
            "addressLocality": "Camelot Layout,Hyderabad",
            "addressRegion": "IN",
            "postalCode": "500084",
            "addressCountry": "INDIA"
          }
        ],
        "sameAs": [
          "https://www.facebook.com/vidhematechnologies",
          "https://www.linkedin.com/company/vidhema-technologies",
          "https://twitter.com/vidhematech"
        ],
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "+1-234-567-8901",
            "email": "support@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          },
          {
            "@type": "ContactPoint",
            "contactType": "sales",
            "telephone": "+1-234-567-8902",
            "email": "sales@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          }
        ],
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "value": 100
        },
        "founder": [
          {
            "@type": "Person",
            "name": "Avinash Verma"
          },
          {
            "@type": "Person",
            "name": "Vivek Chaturvedi"
          },
          {
            "@type": "Person",
            "name": "Anoop Singh Chouhan"
          }
        ]
      }
    })
  },
  microsoftBusiness: {
    id: ' microsoftBusiness-script',
    content: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "microsoftBusinessControllerPage",
      "title": " Microsoft Business Central Solutions | Vidhema Technology",
      "description":   "Optimize your business operations with Vidhema Technology's Microsoft Business Central solutions. Streamline finances, operations, and customer service with our expert implementation and support.",
      "url": "https://vidhema.com/microsoft-business-controller.html",
      "mainEntity": {
        "@type": "Organization",
        "name": "Vidhema Technologies",
        "telephone": "+1-234-567-8900",
        "email": "info@vidhema.com",
        "address": [
          {
            "@type": "PostalAddress",
            "streetAddress": "123 Tech Street",
            "addressLocality": "Silicon Valley",
            "addressRegion": "CA",
            "postalCode": "94000",
            "addressCountry": "US"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "68 ",
            "addressLocality": "CIRCULAR ROAD",
            "addressRegion": "SG",
            "postalCode": "049422",
            "addressCountry": "SINGAPORE"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "7, Shanti Nagar Rd",
            "addressLocality": "Shanthi Nagar,Jaipur",
            "addressRegion": "IN",
            "postalCode": "302020",
            "addressCountry": "INDIA"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "403, Ashirwad Nilayam",
            "addressLocality": "Camelot Layout,Hyderabad",
            "addressRegion": "IN",
            "postalCode": "500084",
            "addressCountry": "INDIA"
          }
        ],
        "sameAs": [
          "https://www.facebook.com/vidhematechnologies",
          "https://www.linkedin.com/company/vidhema-technologies",
          "https://twitter.com/vidhematech"
        ],
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "+1-234-567-8901",
            "email": "support@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          },
          {
            "@type": "ContactPoint",
            "contactType": "sales",
            "telephone": "+1-234-567-8902",
            "email": "sales@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          }
        ],
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "value": 100
        },
        "founder": [
          {
            "@type": "Person",
            "name": "Avinash Verma"
          },
          {
            "@type": "Person",
            "name": "Vivek Chaturvedi"
          },
          {
            "@type": "Person",
            "name": "Anoop Singh Chouhan"
          }
        ]
      }
    })
  },
  microsoftPowerBI: {
    id: '  microsoftPowerBI-script',
    content: JSON.stringify({
      "@context": "https://schema.org",
      "@type": " microsoftPowerBIPage",
      "title": " Microsoft Power BI Services | Data Visualization & Analytics | Vidhema Technology",
      "description":"Transform your data with Vidhema Technology's Microsoft Power BI services. Expert implementation, custom dashboards, and advanced analytics solutions for informed decision-making.",
      "url": "https://vidhema.com/microsoft-power-Bi.html",
      "mainEntity": {
        "@type": "Organization",
        "name": "Vidhema Technologies",
        "telephone": "+1-234-567-8900",
        "email": "info@vidhema.com",
        "address": [
          {
            "@type": "PostalAddress",
            "streetAddress": "123 Tech Street",
            "addressLocality": "Silicon Valley",
            "addressRegion": "CA",
            "postalCode": "94000",
            "addressCountry": "US"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "68 ",
            "addressLocality": "CIRCULAR ROAD",
            "addressRegion": "SG",
            "postalCode": "049422",
            "addressCountry": "SINGAPORE"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "7, Shanti Nagar Rd",
            "addressLocality": "Shanthi Nagar,Jaipur",
            "addressRegion": "IN",
            "postalCode": "302020",
            "addressCountry": "INDIA"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "403, Ashirwad Nilayam",
            "addressLocality": "Camelot Layout,Hyderabad",
            "addressRegion": "IN",
            "postalCode": "500084",
            "addressCountry": "INDIA"
          }
        ],
        "sameAs": [
          "https://www.facebook.com/vidhematechnologies",
          "https://www.linkedin.com/company/vidhema-technologies",
          "https://twitter.com/vidhematech"
        ],
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "+1-234-567-8901",
            "email": "support@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          },
          {
            "@type": "ContactPoint",
            "contactType": "sales",
            "telephone": "+1-234-567-8902",
            "email": "sales@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          }
        ],
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "value": 100
        },
        "founder": [
          {
            "@type": "Person",
            "name": "Avinash Verma"
          },
          {
            "@type": "Person",
            "name": "Vivek Chaturvedi"
          },
          {
            "@type": "Person",
            "name": "Anoop Singh Chouhan"
          }
        ]
      }
    })
  },
  microsoftDynamic: {
    id: ' microsoftDynamic-script',
    content: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "microsoftDynamicPage",
     "title": " Microsoft Dynamics Services | Vidhema Technology",
      "description":"Leverage Vidhema Technology's expertise in Microsoft Dynamics. We offer implementation, customization, and support services to optimize your business processes and drive growth.",
      "url": "https://vidhema.com/microsoft-dynamic.html",
      "mainEntity": {
        "@type": "Organization",
        "name": "Vidhema Technologies",
        "telephone": "+1-234-567-8900",
        "email": "info@vidhema.com",
        "address": [
          {
            "@type": "PostalAddress",
            "streetAddress": "123 Tech Street",
            "addressLocality": "Silicon Valley",
            "addressRegion": "CA",
            "postalCode": "94000",
            "addressCountry": "US"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "68 ",
            "addressLocality": "CIRCULAR ROAD",
            "addressRegion": "SG",
            "postalCode": "049422",
            "addressCountry": "SINGAPORE"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "7, Shanti Nagar Rd",
            "addressLocality": "Shanthi Nagar,Jaipur",
            "addressRegion": "IN",
            "postalCode": "302020",
            "addressCountry": "INDIA"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "403, Ashirwad Nilayam",
            "addressLocality": "Camelot Layout,Hyderabad",
            "addressRegion": "IN",
            "postalCode": "500084",
            "addressCountry": "INDIA"
          }
        ],
        "sameAs": [
          "https://www.facebook.com/vidhematechnologies",
          "https://www.linkedin.com/company/vidhema-technologies",
          "https://twitter.com/vidhematech"
        ],
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "+1-234-567-8901",
            "email": "support@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          },
          {
            "@type": "ContactPoint",
            "contactType": "sales",
            "telephone": "+1-234-567-8902",
            "email": "sales@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          }
        ],
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "value": 100
        },
        "founder": [
          {
            "@type": "Person",
            "name": "Avinash Verma"
          },
          {
            "@type": "Person",
            "name": "Vivek Chaturvedi"
          },
          {
            "@type": "Person",
            "name": "Anoop Singh Chouhan"
          }
        ]
      }
    })
  },
  Oraclesolutions: {
    id: ' Oraclesolutions-script',
    content: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "OraclesolutionsPage",
     "title": " Oracle Development Services | Vidhema Technology",
      "description":"Contact Vidhema Technology for expert Oracle development services. Our team provides custom Oracle solutions to meet your business needs.",
      "url": "https://vidhema.com/oracle-development.html",
      "mainEntity": {
        "@type": "Organization",
        "name": "Vidhema Technologies",
        "telephone": "+1-234-567-8900",
        "email": "info@vidhema.com",
        "address": [
          {
            "@type": "PostalAddress",
            "streetAddress": "123 Tech Street",
            "addressLocality": "Silicon Valley",
            "addressRegion": "CA",
            "postalCode": "94000",
            "addressCountry": "US"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "68 ",
            "addressLocality": "CIRCULAR ROAD",
            "addressRegion": "SG",
            "postalCode": "049422",
            "addressCountry": "SINGAPORE"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "7, Shanti Nagar Rd",
            "addressLocality": "Shanthi Nagar,Jaipur",
            "addressRegion": "IN",
            "postalCode": "302020",
            "addressCountry": "INDIA"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "403, Ashirwad Nilayam",
            "addressLocality": "Camelot Layout,Hyderabad",
            "addressRegion": "IN",
            "postalCode": "500084",
            "addressCountry": "INDIA"
          }
        ],
        "sameAs": [
          "https://www.facebook.com/vidhematechnologies",
          "https://www.linkedin.com/company/vidhema-technologies",
          "https://twitter.com/vidhematech"
        ],
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "+1-234-567-8901",
            "email": "support@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          },
          {
            "@type": "ContactPoint",
            "contactType": "sales",
            "telephone": "+1-234-567-8902",
            "email": "sales@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          }
        ],
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "value": 100
        },
        "founder": [
          {
            "@type": "Person",
            "name": "Avinash Verma"
          },
          {
            "@type": "Person",
            "name": "Vivek Chaturvedi"
          },
          {
            "@type": "Person",
            "name": "Anoop Singh Chouhan"
          }
        ]
      }
    })
  },
  odoosolutions: {
    id: ' odoosolutions-script',
    content: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "odoosolutionsPage",
      "title": " Odoo Development Services | Vidhema Technology",
      "description":"Contact Vidhema Technology for expert Odoo development services. Our team specializes in custom Odoo solutions to enhance your business operations.",
      "url": "https://vidhema.com/odoo-development.html",
      "mainEntity": {
        "@type": "Organization",
        "name": "Vidhema Technologies",
        "telephone": "+1-234-567-8900",
        "email": "info@vidhema.com",
        "address": [
          {
            "@type": "PostalAddress",
            "streetAddress": "123 Tech Street",
            "addressLocality": "Silicon Valley",
            "addressRegion": "CA",
            "postalCode": "94000",
            "addressCountry": "US"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "68 ",
            "addressLocality": "CIRCULAR ROAD",
            "addressRegion": "SG",
            "postalCode": "049422",
            "addressCountry": "SINGAPORE"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "7, Shanti Nagar Rd",
            "addressLocality": "Shanthi Nagar,Jaipur",
            "addressRegion": "IN",
            "postalCode": "302020",
            "addressCountry": "INDIA"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "403, Ashirwad Nilayam",
            "addressLocality": "Camelot Layout,Hyderabad",
            "addressRegion": "IN",
            "postalCode": "500084",
            "addressCountry": "INDIA"
          }
        ],
        "sameAs": [
          "https://www.facebook.com/vidhematechnologies",
          "https://www.linkedin.com/company/vidhema-technologies",
          "https://twitter.com/vidhematech"
        ],
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "+1-234-567-8901",
            "email": "support@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          },
          {
            "@type": "ContactPoint",
            "contactType": "sales",
            "telephone": "+1-234-567-8902",
            "email": "sales@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          }
        ],
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "value": 100
        },
        "founder": [
          {
            "@type": "Person",
            "name": "Avinash Verma"
          },
          {
            "@type": "Person",
            "name": "Vivek Chaturvedi"
          },
          {
            "@type": "Person",
            "name": "Anoop Singh Chouhan"
          }
        ]
      }
    })
  },
  SAPSolutions: {
    id: 'SAPSolutions-script',
    content: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "SAPSolutionsPage",
      "title": "sap solutions Services | Vidhema Technology",
      "description":"Contact Vidhema Technology for expert sap development services. Our team specializes in custom sap solutions to enhance your business operations.",
      "url": "https://vidhema.com/sap-solution.html",
      "mainEntity": {
        "@type": "Organization",
        "name": "Vidhema Technologies",
        "telephone": "+1-234-567-8900",
        "email": "info@vidhema.com",
        "address": [
          {
            "@type": "PostalAddress",
            "streetAddress": "123 Tech Street",
            "addressLocality": "Silicon Valley",
            "addressRegion": "CA",
            "postalCode": "94000",
            "addressCountry": "US"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "68 ",
            "addressLocality": "CIRCULAR ROAD",
            "addressRegion": "SG",
            "postalCode": "049422",
            "addressCountry": "SINGAPORE"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "7, Shanti Nagar Rd",
            "addressLocality": "Shanthi Nagar,Jaipur",
            "addressRegion": "IN",
            "postalCode": "302020",
            "addressCountry": "INDIA"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "403, Ashirwad Nilayam",
            "addressLocality": "Camelot Layout,Hyderabad",
            "addressRegion": "IN",
            "postalCode": "500084",
            "addressCountry": "INDIA"
          }
        ],
        "sameAs": [
          "https://www.facebook.com/vidhematechnologies",
          "https://www.linkedin.com/company/vidhema-technologies",
          "https://twitter.com/vidhematech"
        ],
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "+1-234-567-8901",
            "email": "support@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          },
          {
            "@type": "ContactPoint",
            "contactType": "sales",
            "telephone": "+1-234-567-8902",
            "email": "sales@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          }
        ],
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "value": 100
        },
        "founder": [
          {
            "@type": "Person",
            "name": "Avinash Verma"
          },
          {
            "@type": "Person",
            "name": "Vivek Chaturvedi"
          },
          {
            "@type": "Person",
            "name": "Anoop Singh Chouhan"
          }
        ]
      }
    })
  }, 
  MicrosoftThreeSixtyFive: {
    id: 'MicrosoftThreeSixtyFive-script',
    content: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "MicrosoftThreeSixtyFivePage",
     "title": "Microsoft 365 Services | Vidhema Technology",
      "description":"Enhance your business productivity with Vidhema Technology's Microsoft 365 services. Expert implementation, migration, and support for all Microsoft 365 applications.",
      "url": "http://localhost:4200/microsoft-365.html",
      "mainEntity": {
        "@type": "Organization",
        "name": "Vidhema Technologies",
        "telephone": "+1-234-567-8900",
        "email": "info@vidhema.com",
        "address": [
          {
            "@type": "PostalAddress",
            "streetAddress": "123 Tech Street",
            "addressLocality": "Silicon Valley",
            "addressRegion": "CA",
            "postalCode": "94000",
            "addressCountry": "US"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "68 ",
            "addressLocality": "CIRCULAR ROAD",
            "addressRegion": "SG",
            "postalCode": "049422",
            "addressCountry": "SINGAPORE"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "7, Shanti Nagar Rd",
            "addressLocality": "Shanthi Nagar,Jaipur",
            "addressRegion": "IN",
            "postalCode": "302020",
            "addressCountry": "INDIA"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "403, Ashirwad Nilayam",
            "addressLocality": "Camelot Layout,Hyderabad",
            "addressRegion": "IN",
            "postalCode": "500084",
            "addressCountry": "INDIA"
          }
        ],
        "sameAs": [
          "https://www.facebook.com/vidhematechnologies",
          "https://www.linkedin.com/company/vidhema-technologies",
          "https://twitter.com/vidhematech"
        ],
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "+1-234-567-8901",
            "email": "support@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          },
          {
            "@type": "ContactPoint",
            "contactType": "sales",
            "telephone": "+1-234-567-8902",
            "email": "sales@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          }
        ],
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "value": 100
        },
        "founder": [
          {
            "@type": "Person",
            "name": "Avinash Verma"
          },
          {
            "@type": "Person",
            "name": "Vivek Chaturvedi"
          },
          {
            "@type": "Person",
            "name": "Anoop Singh Chouhan"
          }
        ]
      }
    })
  }, 
  Salesforce: {
    id: 'Salesforce-script',
    content: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Salesforcepage",
      "title": "Salesforce Development Services | Vidhema Technology",
      "description":"Contact Vidhema Technology for expert Salesforce development services. Our team delivers custom Salesforce solutions to optimize your business processes",
      "url": "https://vidhema.com/salesforce-development.html",
      "mainEntity": {
        "@type": "Organization",
        "name": "Vidhema Technologies",
        "telephone": "+1-234-567-8900",
        "email": "info@vidhema.com",
        "address": [
          {
            "@type": "PostalAddress",
            "streetAddress": "123 Tech Street",
            "addressLocality": "Silicon Valley",
            "addressRegion": "CA",
            "postalCode": "94000",
            "addressCountry": "US"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "68 ",
            "addressLocality": "CIRCULAR ROAD",
            "addressRegion": "SG",
            "postalCode": "049422",
            "addressCountry": "SINGAPORE"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "7, Shanti Nagar Rd",
            "addressLocality": "Shanthi Nagar,Jaipur",
            "addressRegion": "IN",
            "postalCode": "302020",
            "addressCountry": "INDIA"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "403, Ashirwad Nilayam",
            "addressLocality": "Camelot Layout,Hyderabad",
            "addressRegion": "IN",
            "postalCode": "500084",
            "addressCountry": "INDIA"
          }
        ],
        "sameAs": [
          "https://www.facebook.com/vidhematechnologies",
          "https://www.linkedin.com/company/vidhema-technologies",
          "https://twitter.com/vidhematech"
        ],
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "+1-234-567-8901",
            "email": "support@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          },
          {
            "@type": "ContactPoint",
            "contactType": "sales",
            "telephone": "+1-234-567-8902",
            "email": "sales@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          }
        ],
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "value": 100
        },
        "founder": [
          {
            "@type": "Person",
            "name": "Avinash Verma"
          },
          {
            "@type": "Person",
            "name": "Vivek Chaturvedi"
          },
          {
            "@type": "Person",
            "name": "Anoop Singh Chouhan"
          }
        ]
      }
    })
  }, 
  hubspot: {
    id: 'Hubspot-script',
    content: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Hubspotpage",
      "title": "Hubspot CRM Services | Vidhema Technology",
      "description":"Contact Vidhema Technology for expert Hubspot CRM services. Our team delivers custom Hubspot solutions to optimize your business processes",
      "url": "https://vidhema.com/prestashop.html",
      "mainEntity": {
        "@type": "Organization",
        "name": "Vidhema Technologies",
        "telephone": "+1-234-567-8900",
        "email": "info@vidhema.com",
        "address": [
          {
            "@type": "PostalAddress",
            "streetAddress": "123 Tech Street",
            "addressLocality": "Silicon Valley",
            "addressRegion": "CA",
            "postalCode": "94000",
            "addressCountry": "US"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "68 ",
            "addressLocality": "CIRCULAR ROAD",
            "addressRegion": "SG",
            "postalCode": "049422",
            "addressCountry": "SINGAPORE"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "7, Shanti Nagar Rd",
            "addressLocality": "Shanthi Nagar,Jaipur",
            "addressRegion": "IN",
            "postalCode": "302020",
            "addressCountry": "INDIA"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "403, Ashirwad Nilayam",
            "addressLocality": "Camelot Layout,Hyderabad",
            "addressRegion": "IN",
            "postalCode": "500084",
            "addressCountry": "INDIA"
          }
        ],
        "sameAs": [
          "https://www.facebook.com/vidhematechnologies",
          "https://www.linkedin.com/company/vidhema-technologies",
          "https://twitter.com/vidhematech"
        ],
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "+1-234-567-8901",
            "email": "support@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          },
          {
            "@type": "ContactPoint",
            "contactType": "sales",
            "telephone": "+1-234-567-8902",
            "email": "sales@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          }
        ],
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "value": 100
        },
        "founder": [
          {
            "@type": "Person",
            "name": "Avinash Verma"
          },
          {
            "@type": "Person",
            "name": "Vivek Chaturvedi"
          },
          {
            "@type": "Person",
            "name": "Anoop Singh Chouhan"
          }
        ]
      }
    })
  }, 
  Tableausolutions: {
    id: 'Tableausolutions-script',
    content: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Tableausolutionspage",
       "title": " Tableau solutions Services | Vidhema Technology",
      "description":"Contact Vidhema Technology for expert Tableau solutions services. Our team delivers custom Tableau solutions to optimize your business processes",
      "url": "https://vidhema.com/tableau.html",
      "mainEntity": {
        "@type": "Organization",
        "name": "Vidhema Technologies",
        "telephone": "+1-234-567-8900",
        "email": "info@vidhema.com",
        "address": [
          {
            "@type": "PostalAddress",
            "streetAddress": "123 Tech Street",
            "addressLocality": "Silicon Valley",
            "addressRegion": "CA",
            "postalCode": "94000",
            "addressCountry": "US"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "68 ",
            "addressLocality": "CIRCULAR ROAD",
            "addressRegion": "SG",
            "postalCode": "049422",
            "addressCountry": "SINGAPORE"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "7, Shanti Nagar Rd",
            "addressLocality": "Shanthi Nagar,Jaipur",
            "addressRegion": "IN",
            "postalCode": "302020",
            "addressCountry": "INDIA"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "403, Ashirwad Nilayam",
            "addressLocality": "Camelot Layout,Hyderabad",
            "addressRegion": "IN",
            "postalCode": "500084",
            "addressCountry": "INDIA"
          }
        ],
        "sameAs": [
          "https://www.facebook.com/vidhematechnologies",
          "https://www.linkedin.com/company/vidhema-technologies",
          "https://twitter.com/vidhematech"
        ],
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "+1-234-567-8901",
            "email": "support@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          },
          {
            "@type": "ContactPoint",
            "contactType": "sales",
            "telephone": "+1-234-567-8902",
            "email": "sales@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          }
        ],
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "value": 100
        },
        "founder": [
          {
            "@type": "Person",
            "name": "Avinash Verma"
          },
          {
            "@type": "Person",
            "name": "Vivek Chaturvedi"
          },
          {
            "@type": "Person",
            "name": "Anoop Singh Chouhan"
          }
        ]
      }
    })
  }, 
  AdobeExperience: {
    id: 'AdobeExperience-script',
    content: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "AdobeExperiencepage",
      "title": "Adobe experience Services | Vidhema Technology",
      "description": "Contact Vidhema Technology for expert Adobe solutions services. Our team delivers custom Adobe solutions to optimize your business processes",
      "url": "https://vidhema.com/adobe-experience.html",
      "mainEntity": {
        "@type": "Organization",
        "name": "Vidhema Technologies",
        "telephone": "+1-234-567-8900",
        "email": "info@vidhema.com",
        "address": [
          {
            "@type": "PostalAddress",
            "streetAddress": "123 Tech Street",
            "addressLocality": "Silicon Valley",
            "addressRegion": "CA",
            "postalCode": "94000",
            "addressCountry": "US"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "68 ",
            "addressLocality": "CIRCULAR ROAD",
            "addressRegion": "SG",
            "postalCode": "049422",
            "addressCountry": "SINGAPORE"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "7, Shanti Nagar Rd",
            "addressLocality": "Shanthi Nagar,Jaipur",
            "addressRegion": "IN",
            "postalCode": "302020",
            "addressCountry": "INDIA"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "403, Ashirwad Nilayam",
            "addressLocality": "Camelot Layout,Hyderabad",
            "addressRegion": "IN",
            "postalCode": "500084",
            "addressCountry": "INDIA"
          }
        ],
        "sameAs": [
          "https://www.facebook.com/vidhematechnologies",
          "https://www.linkedin.com/company/vidhema-technologies",
          "https://twitter.com/vidhematech"
        ],
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "+1-234-567-8901",
            "email": "support@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          },
          {
            "@type": "ContactPoint",
            "contactType": "sales",
            "telephone": "+1-234-567-8902",
            "email": "sales@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          }
        ],
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "value": 100
        },
        "founder": [
          {
            "@type": "Person",
            "name": "Avinash Verma"
          },
          {
            "@type": "Person",
            "name": "Vivek Chaturvedi"
          },
          {
            "@type": "Person",
            "name": "Anoop Singh Chouhan"
          }
        ]
      }
    })
  }, 
  microsoftAzure: {
    id:'microsoftAzure-script',
    content: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "microsoftAzurepage",
      "title": "Microsoft Azure Services | Cloud Solutions by Vidhema Technology",
      "description": "Leverage Vidhema Technology's expertise in Microsoft Azure cloud services. We offer tailored Azure solutions, migration services, and managed cloud infrastructure to optimize your business operations.",
      "url": "https://vidhema.com/microsoft-azure.html",
      "mainEntity": {
        "@type": "Organization",
        "name": "Vidhema Technologies",
        "telephone": "+1-234-567-8900",
        "email": "info@vidhema.com",
        "address": [
          {
            "@type": "PostalAddress",
            "streetAddress": "123 Tech Street",
            "addressLocality": "Silicon Valley",
            "addressRegion": "CA",
            "postalCode": "94000",
            "addressCountry": "US"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "68 ",
            "addressLocality": "CIRCULAR ROAD",
            "addressRegion": "SG",
            "postalCode": "049422",
            "addressCountry": "SINGAPORE"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "7, Shanti Nagar Rd",
            "addressLocality": "Shanthi Nagar,Jaipur",
            "addressRegion": "IN",
            "postalCode": "302020",
            "addressCountry": "INDIA"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "403, Ashirwad Nilayam",
            "addressLocality": "Camelot Layout,Hyderabad",
            "addressRegion": "IN",
            "postalCode": "500084",
            "addressCountry": "INDIA"
          }
        ],
        "sameAs": [
          "https://www.facebook.com/vidhematechnologies",
          "https://www.linkedin.com/company/vidhema-technologies",
          "https://twitter.com/vidhematech"
        ],
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "+1-234-567-8901",
            "email": "support@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          },
          {
            "@type": "ContactPoint",
            "contactType": "sales",
            "telephone": "+1-234-567-8902",
            "email": "sales@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          }
        ],
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "value": 100
        },
        "founder": [
          {
            "@type": "Person",
            "name": "Avinash Verma"
          },
          {
            "@type": "Person",
            "name": "Vivek Chaturvedi"
          },
          {
            "@type": "Person",
            "name": "Anoop Singh Chouhan"
          }
        ]
      }
    })
  }, 
  iosdevelopment: {
    id:'ios-script',
    content: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "iospage",
      "title": "Acclaimed ios app development company offering ios development services",
      "description": "Having years of experience in iOS development, we are a highly renowned ios app development company. Get the best ios app development services from our expert ios app development team. We are committed on delivering end-to-end projects to our customers within a given time.",
      "url": "https://www.vidhema.com/ios-app-development.html",
      "mainEntity": {
        "@type": "Organization",
        "name": "Vidhema Technologies",
        "telephone": "+1-234-567-8900",
        "email": "info@vidhema.com",
        "address": [
          {
            "@type": "PostalAddress",
            "streetAddress": "123 Tech Street",
            "addressLocality": "Silicon Valley",
            "addressRegion": "CA",
            "postalCode": "94000",
            "addressCountry": "US"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "68 ",
            "addressLocality": "CIRCULAR ROAD",
            "addressRegion": "SG",
            "postalCode": "049422",
            "addressCountry": "SINGAPORE"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "7, Shanti Nagar Rd",
            "addressLocality": "Shanthi Nagar,Jaipur",
            "addressRegion": "IN",
            "postalCode": "302020",
            "addressCountry": "INDIA"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "403, Ashirwad Nilayam",
            "addressLocality": "Camelot Layout,Hyderabad",
            "addressRegion": "IN",
            "postalCode": "500084",
            "addressCountry": "INDIA"
          }
        ],
        "sameAs": [
          "https://www.facebook.com/vidhematechnologies",
          "https://www.linkedin.com/company/vidhema-technologies",
          "https://twitter.com/vidhematech"
        ],
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "+1-234-567-8901",
            "email": "support@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          },
          {
            "@type": "ContactPoint",
            "contactType": "sales",
            "telephone": "+1-234-567-8902",
            "email": "sales@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          }
        ],
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "value": 100
        },
        "founder": [
          {
            "@type": "Person",
            "name": "Avinash Verma"
          },
          {
            "@type": "Person",
            "name": "Vivek Chaturvedi"
          },
          {
            "@type": "Person",
            "name": "Anoop Singh Chouhan"
          }
        ]
      }
    })
  }, 
  AndroidAppDevelopment: {
    id:'AndroidAppDevelopment-script',
    content: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "AndroidAppDevelopmentpage",
      "title": "Android App Development Company | Vidhema Technology",
      "description": "Vidhema Technology is a leading Android app development company. We create high-quality, user-friendly, and feature-rich Android applications tailored to your business needs.",
      "url": "https://vidhema.com/android-app-development.html",
      "mainEntity": {
        "@type": "Organization",
        "name": "Vidhema Technologies",
        "telephone": "+1-234-567-8900",
        "email": "info@vidhema.com",
        "address": [
          {
            "@type": "PostalAddress",
            "streetAddress": "123 Tech Street",
            "addressLocality": "Silicon Valley",
            "addressRegion": "CA",
            "postalCode": "94000",
            "addressCountry": "US"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "68 ",
            "addressLocality": "CIRCULAR ROAD",
            "addressRegion": "SG",
            "postalCode": "049422",
            "addressCountry": "SINGAPORE"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "7, Shanti Nagar Rd",
            "addressLocality": "Shanthi Nagar,Jaipur",
            "addressRegion": "IN",
            "postalCode": "302020",
            "addressCountry": "INDIA"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "403, Ashirwad Nilayam",
            "addressLocality": "Camelot Layout,Hyderabad",
            "addressRegion": "IN",
            "postalCode": "500084",
            "addressCountry": "INDIA"
          }
        ],
        "sameAs": [
          "https://www.facebook.com/vidhematechnologies",
          "https://www.linkedin.com/company/vidhema-technologies",
          "https://twitter.com/vidhematech"
        ],
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "+1-234-567-8901",
            "email": "support@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          },
          {
            "@type": "ContactPoint",
            "contactType": "sales",
            "telephone": "+1-234-567-8902",
            "email": "sales@vidhema.com",
            "availableLanguage": ["English", "Hindi"]
          }
        ],
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "value": 100
        },
        "founder": [
          {
            "@type": "Person",
            "name": "Avinash Verma"
          },
          {
            "@type": "Person",
            "name": "Vivek Chaturvedi"
          },
          {
            "@type": "Person",
            "name": "Anoop Singh Chouhan"
          }
        ]
      }
    })
  }, 
};
